import OAUTH from './oauth'
import { config } from 'src/config'

const BASE_URL = config('api.url', 'http://localhost:8000/')
const GRAPHQL_URL = config('gql.url', 'http://localhost:8000/') + 'api/'
const URL = BASE_URL + 'api/'
const AWS_URL = config('services.aws.url', 'https://d31tixrdv8d510.cloudfront.net/')
const OZARU_URL = config('services.ozaru.url', ' https://n8n.ozaru.app/')

export default {
  BASE_URL,
  GRAPHQL_URL,
  URL,
  OAUTH,
  AWS_URL,
  OZARU_URL
}
